import React, { FunctionComponent } from 'react';
import { useAppState } from 'src/shared/appState';
import styled from 'styled-components';
import Loader from '../loader';

const StyledLoading = styled.div`
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.7);
    z-index: 100;
`;

const OverlayLoading: FunctionComponent<{ forceShow?: boolean }> = (props) => {
    const { state } = useAppState();
    return (
        <React.Fragment>
            {(state.showLoading || props.forceShow) && (
                <StyledLoading>
                    <Loader />
                </StyledLoading>
            )}
        </React.Fragment>
    );
};

export default OverlayLoading;
